import { Component } from "react";
import { Button } from "react-bootstrap";
import { bindActionCreators } from 'redux';
import { actions } from "react-redux-form";
import { connect } from "react-redux";
import ButtonIcon from "../../../../../../button";
import store from "../../../../../../../store";

import { CustomDropdown } from "../../../../../../common/custom-form/custom-dropdown.component";
import Translation from "../../../../../../common/translation/translation.component";
import { CONFIRMATION_VALUE, TRANSLATIONS as translation } from "../../../../../../../utils/constant.utils";
import { NotificationModal } from "../../../../../../common/modal/notification-modal.component";
import { InputFieldFloatingLabel as InputField } from "../../../../../../common/custom-form/select-filter.component";
import { ACTION_TYPES, MAX_LENGTH, MODAL_CUSTOM_MESSAGE, OPERATOR_FILTERS, RECHARGE_INVENTORY_TYPE } from "../../../../../../../constants/external-constants";
import { ConfirmationNotificationModal } from "../../../../../../common/modal/confirmation-modal.component";
import { SelectFieldFloatingLabel as Select } from "../../../../../../common/custom-form/select-filter.component";
import DATEPICKER_OR from "../../../../../../common/custom-form/custom-date-picker.component";
import { areDataEqual } from "../../../../../../../utils/helpers.utils";
import DateRange from "../../../../../../common/custom-form/custom-date-range-component";
import TableWithButton from "../../../../../../common/details-table/table-with-button.component";
import { OutputConfigurationDetailsActions } from "../../../../../../../store/external/recharge-reducer/output-configuraton-details/output-configuration-details.reducer";

class OutputScope extends Component {
    constructor(props) {
        super(props);
        this.state={
            dataTable:[[]],
            showWarning: true,
            modalMessage: '',
            value: '',
            date: null,
            activeDropdown: false,
            updateOutputConfig: false,
            rowData: [],
            filterType: null,
            rowIndex: 0,
            haveError: false,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
        }
    }

    componentDidMount() {
        const { data } = this.props

        if (data && data.length > 0) {
            this.setState((prevState) => {
                const updatedDataTable = [...prevState.dataTable];
                
                // Ensure updatedDataTable[0] exists and is an array
                if (!Array.isArray(updatedDataTable[0])) {
                    updatedDataTable[0] = [];
                }

                // Add all items in `data` to `updatedDataTable[0]`
                updatedDataTable[0] = [...updatedDataTable[0], ...data];

                return { dataTable: updatedDataTable };
            });
        }
    }

    validateFormData = () => {
        const { circuitDataTable, equipmentDataTable, otcDataTable } = this.props.outputConfigurationDetails;
        const { fieldForm, outputScope } = this.props;
        const { isUpdate, rowIndex } = this.state;
 
        const dataList =
            outputScope === RECHARGE_INVENTORY_TYPE.Circuit.id
                ? circuitDataTable
                : outputScope === RECHARGE_INVENTORY_TYPE.Equipment.id
                    ? equipmentDataTable
                    : otcDataTable;
 
        const items = dataList?.dataTable?.[0]?.dataItem || [];
 
        const alreadyExist = items.some(item =>
            item.FilterID === parseInt(fieldForm.FilterID) &&
            item.OperatorID === parseInt(fieldForm.OperatorID) &&
            item.OptionID === parseInt(fieldForm.OptionID) &&
            item.Value === fieldForm.Value &&
            (!isUpdate || fieldForm.ID !== item.ID)
        );
 
        if (alreadyExist) {
            this.setState({
                haveError: true,
                showNotif: true,
                haveFieldError: true,
                modalMessage: "Same record already exists."
            });
            return true;
        }
 
        this.onClickAdd();
    };

    fetchDropDownValue = (data, filterType = null) => {
        this.setState({
            rowData: data
            , filterType: filterType
        })
    }

    deleteScopeDate = (index) => {
        const { deleteOutputScopeData, outputScope, outputScopeExtractId, dataItem } = this.props;

        deleteOutputScopeData(index, outputScope);
        this.props.handleResetForm(outputScope);
        this.setState({
            activeDropdown: false,
            updateSimDetails: false,
            isUpdate: false
        })

        if(dataItem.length > 1){
            this.props.updateOutputScopeCount(outputScopeExtractId)
        }
    }

    onClickAdd = (buttonType) => {
        this.setState({
            showModal: true,
            haveError: false
        })
    }

    handleConfirmationModal = (buttonType) => {
        const { outputScope, handleResetForm, addUpdateScopeItem, outputScopeExtractId } = this.props;

        if (buttonType === CONFIRMATION_VALUE.Ok) {
            addUpdateScopeItem(outputScope);

            this.setState(prev => ({
                showModal: !prev.showModal,
                enableEdit: false,
                activeDropdown: false,
                isUpdate: false
            }))
            handleResetForm(outputScope);
        } else {
            this.setState({
                showModal: false,
                activeDropdown: false,
            });
        }
        this.props.updateOutputScopeCount(outputScopeExtractId)
    }

    toLocaleLanguage = (key, isCapitalize=true) => {
            const { locale } = this.props;
            if (locale === null || locale === '')
                return translation[translation['defaultLocaleLanguage']][key];
            
            return isCapitalize ? translation[locale][key]?.toUpperCase() : translation[locale][key];
    }

    handleCancel = () => {
        const { outputScope } = this.props;

        this.props.handleResetForm(outputScope);

        this.setState({
            activeDropdown: false,
            isUpdate: false
        })
    }

    onChangeDates = (dates) => {
        const [start, end] = dates;

        if (this.props.outputScope === RECHARGE_INVENTORY_TYPE.Circuit.id) {
            store.dispatch(actions.change('outputConfigurationDetailsForm.circuitOutputScope.StartDateValue', start))
            store.dispatch(actions.change('outputConfigurationDetailsForm.circuitOutputScope.EndDateValue', end))
        }
        else if (this.props.outputScope === RECHARGE_INVENTORY_TYPE.Equipment.id) {
            store.dispatch(actions.change('outputConfigurationDetailsForm.equipmentOutputScope.StartDateValue', start))
            store.dispatch(actions.change('outputConfigurationDetailsForm.equipmentOutputScope.EndDateValue', end))
        }
        else {
            store.dispatch(actions.change('outputConfigurationDetailsForm.otcOutputScope.StartDateValue', start))
            store.dispatch(actions.change('outputConfigurationDetailsForm.otcOutputScope.EndDateValue', end))
        }
    };

    onRowClick = (index) => {
        const { viewOutputScope, outputScope, isReadAndWrite } = this.props;
        viewOutputScope(index, outputScope);

        this.setState({
            activeDropdown: isReadAndWrite ? true : false,
            isUpdate: true,
            rowIndex: index
        });
    }

    handleCloseNotif = () => {
        this.setState({ showNotif: false });
    }   

    handleOpenNotif = () => {
        this.setState({
            showNotif: true,
            notifTitle: 'deleted'
        });
    }

    enableUpdateBtn = () => {
        const { outputScope, filterType, fieldForm } = this.props
        const { rowIndex } = this.state
        const { circuitDataTable, equipmentDataTable, otcDataTable } = this.props.outputConfigurationDetails;

        const SCOPE_MAP = {
            [RECHARGE_INVENTORY_TYPE.Circuit.id]: {
                scopeDataTable: circuitDataTable,
            },
            [RECHARGE_INVENTORY_TYPE.Equipment.id]: {
                scopeDataTable: equipmentDataTable,
            },
            [RECHARGE_INVENTORY_TYPE.OTC.id]: {
                scopeDataTable: otcDataTable,
            }
        };

        const { scopeDataTable } = SCOPE_MAP[outputScope] || {};

        const disableValue = !fieldForm.FilterID || filterType !== OPERATOR_FILTERS.textbox.filterType;
        const disableDate = !fieldForm.FilterID || fieldForm.OperatorID == '' || filterType !== OPERATOR_FILTERS.date.filterType;

        const { ID: _, ...formWithoutId } = fieldForm || {};
        const { ID: __, ...scopeWithoutId } = scopeDataTable?.dataTable[0]?.dataItem[rowIndex] || {};

        const enableUpdateBtn = !fieldForm.FilterID ||
            !fieldForm.OperatorID ||
            !fieldForm.OptionID ||
            (!fieldForm.Value && !disableValue) || (!fieldForm.DateValue && !disableDate && fieldForm.StartDateValue == null && fieldForm.EndDateValue == null) ||
            (fieldForm.DateValue == null && !fieldForm.StartDateValue && !fieldForm.EndDateValue && !disableDate) ||
            (areDataEqual(formWithoutId, scopeWithoutId));

        return enableUpdateBtn;
    }

    handleExtractDisable = () => {
        const { dataItem } = this.props

        if(dataItem){
            return false;
        }
        return true;
    }

    toggleActiveState = () => {
        this.setState(prevState => ({ activeDropdown: this.props.isReadAndWrite ? !prevState.activeDropdown : false }));
    }

    onClickExtract = (e) => {
        const { outputScopeExtractId } = this.props
        if (window.confirm(this.state.exportAlertMsg)) {
            this.props.extractOutputScope(outputScopeExtractId);
        }
    };

    render() {
        const { dataTable, modalMessage, isUpdate } = this.state;
        const { title, columnData, operatorData, optionData, optionLabelKey, fieldForm, fieldProp, extractHoverMessage,
            outputScope, filterType, addTooltipText, updateTooltipText, dataItem, extractCount, isCreateNew, isExtractDisabled } = this.props;
        const { circuitDataTable, outputColumnsHeaders, outputScopeHeaders } = this.props.outputConfigurationDetails;

        const disableValue = !fieldForm.FilterID || filterType !== OPERATOR_FILTERS.textbox.filterType;
        const disableDate = !fieldForm.FilterID || filterType !== OPERATOR_FILTERS.date.filterType;
        const isGreaterThanOrEqual30 = dataItem.length >= 30;
        const disableAddBtn = !fieldForm.FilterID || !fieldForm.OperatorID || !fieldForm.OptionID ||
                              (!fieldForm.Value && !disableValue) || (!fieldForm.DateValue && !disableDate && fieldForm.StartDateValue == null && fieldForm.EndDateValue == null) ||
                              (fieldForm.DateValue == null && !fieldForm.StartDateValue && !fieldForm.EndDateValue && !disableDate) || isGreaterThanOrEqual30;

        const dataList = [{
            "HeaderItem": outputScopeHeaders,
            "dataItem": dataItem
        }]

        console.log(title, fieldForm)

        return(
            <div>
                <CustomDropdown
                    label={<Translation translationKey={title} />}
                    activeDropdown={this.state.activeDropdown}
                    toggleActiveState={this.toggleActiveState}
                >
                <div className="add-sim-container add-cost-allocation-cont"> 
                    <div className="details-form_layout--scope">
                        <div className="details-2-col-82w-container">
                            <NotificationModal
                                show={this.state.showNotif}
                                title={this.state.haveError ? 'Error' : 'Success'}
                                message={modalMessage}
                                handleModal={this.handleCloseNotif}
                                customClass={'comment-notification-modal notification-footer modal-text-bold'}
                            />

                            <Select
                                className="form-select required"
                                label={`${this.toLocaleLanguage('column')}`}
                                options={columnData}
                                value={fieldForm.FilterID}
                                placeholder={this.toLocaleLanguage('select_placeholder', false)}
                                isError={false}
                                fieldProp={fieldProp+'FilterID'}
                                optionLabelKey={optionLabelKey}
                                onChangeAction={(e, v) => this.props.filterOperatorOptions(e, v, outputScope)}
                            />

                            <Select
                                className="form-select required"
                                label={`${this.toLocaleLanguage('operator')}`}
                                options={operatorData}
                                value={fieldForm.OperatorID}
                                placeholder={this.toLocaleLanguage('select_placeholder', false)}
                                isError={false}
                                fieldProp={fieldProp+'OperatorID'}
                                onChangeAction={(e, v) => this.props.resetDateField(e, v, outputScope)}
                            />

                            <InputField
                                className={`form-control ${!disableValue ? 'required' : ''}`}
                                type="text"
                                label={this.toLocaleLanguage('value')}
                                value={fieldForm.Value}
                                fieldProp={fieldProp+'Value'}
                                maxLength={MAX_LENGTH.limit_255}
                                disabled={disableValue}
                                placeholder={disableValue ? '' : `${this.toLocaleLanguage('enter_text_placeholder', false)}`}
                            />
                                {parseInt(fieldForm.OperatorID) === 1 ?
                                    <DateRange
                                        className="form-select"
                                        dateOnly={true}
                                        label={`${this.toLocaleLanguage('date')}`}
                                        placeholder={`${this.toLocaleLanguage('select_date', false)}`}
                                        startDate={fieldForm.StartDateValue}
                                        endDate={fieldForm.EndDateValue}
                                        dateSelected={fieldForm.StartDateValue}
                                        onChange={this.onChangeDates}
                                        requiredField={!disableDate}
                                        isDisable={disableDate}
                                    />
                                    :
                                    <DATEPICKER_OR
                                        dateOnly={true}
                                        label={`${this.toLocaleLanguage('date')}`}
                                        placeholder={`${this.toLocaleLanguage('select_date', false)}`}
                                        startDate={fieldForm.DateValue}
                                        selectedDate={(date) => this.props.FormChange(fieldProp + 'DateValue', date)}
                                        isDisable={disableDate}
                                        requiredField={!disableDate}
                                    />
                                }
                            <Select
                                className="form-select required"
                                label={`${this.toLocaleLanguage('option')}`}
                                options={optionData}
                                value={fieldForm.OptionID}
                                placeholder={this.toLocaleLanguage('select_placeholder', false)}
                                isError={false}
                                fieldProp={fieldProp+'OptionID'}
                            />
                    </div>

                    <div className="add-button-container custom-add-button flex-column align-items-baseline">

                        <div className="btn-container d-flex gap-2">
                            <div className="btn-tooltiptext">
                                <Button variant="outline-secondary" className="btn-custom-violet-hover-outline" onClick={this.handleCancel}>Cancel</Button>
                                {/* <span className="tooltip-text">{<Translation translationKey="cancel_adding_plan_component" />}</span> */}
                            </div>

                            <ConfirmationNotificationModal
                                show={this.state.showModal}
                                message={isUpdate ? MODAL_CUSTOM_MESSAGE.update_details : MODAL_CUSTOM_MESSAGE.add_details}
                                title={isUpdate ? ACTION_TYPES.Update : ACTION_TYPES.Add}
                                handleModal={this.handleConfirmationModal}
                                customClass={'comment-notification-modal modal-text-bold'}
                            />

                            <div className={'btn-tooltiptext'}>
                                    <Button
                                        disabled={isUpdate ? this.enableUpdateBtn() : disableAddBtn}
                                        onClick={this.validateFormData}
                                        variant="primary"
                                        className="btn-add"
                                    >
                                        {`${isUpdate ? ACTION_TYPES.Update : ACTION_TYPES.Add}`}

                                    </Button>
                                <span className="tooltip-text"><Translation translationKey={isUpdate ? updateTooltipText : addTooltipText} /></span>
                            </div>

                        </div>
                    </div>
                            
                  </div>                    

                    </div>
                </CustomDropdown>
                {dataList[0].dataItem.length > 0 &&
                    < div className={`table-no-scroll details-table-container add-equipment-container`}>
                         {!isCreateNew && (                 
                            <div className="d-flex justify-content-end">
                                <div className="tooltip-container">
                                    <div className={'btn-tooltiptext'}>
                                        <ButtonIcon
                                            onClick={(e) => this.onClickExtract(e)}
                                            iconLeft="cloud-arrow-down"
                                            iconSize="17px"
                                            customClassName="header-option-list header-filter-button"
                                            labelName="Extract List"
                                            isDisable={!isExtractDisabled}
                                        />
                                        <div>
                                            <span className="tooltip-text"><Translation translationKey={extractHoverMessage} />: {extractCount} <Translation translationKey={"records"} /></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                         )}
                        <TableWithButton
                            classNameWrapper={`table-details-wrapper table-clickable table-max-width table-scroll-wrapper ${dataItem?.length > 5 ? 'table-has-scrollbar' : ''} me-0`}
                            datatable={dataList}
                            haveExternalDeleteBtn={this.props.isReadAndWrite ? true : false}
                            deleteAction={(index) => this.deleteScopeDate(index)}
                            rowClickAction={this.onRowClick}
                            handleOpenNotif={this.handleOpenNotif}
                            hideDeleteBtn={false}
                            updateNotifTitle={this.updateNotifTitle}    
                            deleteTooltip={<Translation translationKey={"delete_record"}/>}
                            handleCloseNotif={this.handleCloseNotif}
                        />
                    </div>
                }
            </div>
        )
    }
}

export default connect(
    state => {
        const { translation
            , adminSetting
            , outputConfigurationDetails } = state;
        return {
            ...translation
            , adminSetting
            , outputConfigurationDetails
        }
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, OutputConfigurationDetailsActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        },
    })
)(OutputScope);